import AxiosInstance from "../axios/AxiosInstance";

const releveHeuresService = {
  // Récupérer tous les relevés d'heures pour le client connecté
  async getAllForClient() {
    try {
      const response = await AxiosInstance.get('/releve-heures/client');
      console.log(response.data)
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des relevés d\'heures:', error);
      throw error;
    }
  },

  // Récupérer un relevé d'heures par ID
  // Note: Le backend n'a pas d'endpoint GET /:id, donc on récupère tous les relevés du client
  // et on filtre côté frontend
  async getById(id) {
    try {
      const response = await AxiosInstance.get('/releve-heures/client');
      const timesheets = response.data;

      // Filtrer pour trouver le relevé avec l'ID correspondant
      const timesheet = timesheets.find(ts => ts._id === id);

      if (!timesheet) {
        throw new Error(`Relevé d'heures avec l'ID ${id} non trouvé`);
      }

      return timesheet;
    } catch (error) {
      console.error('Erreur lors de la récupération du relevé d\'heures:', error);
      throw error;
    }
  },

  // Récupérer les relevés d'heures par semaine
  // Note: Filtrage côté frontend car l'endpoint /week n'est pas exposé dans le contrôleur
  async getByWeek(startDate, endDate) {
    try {
      const response = await AxiosInstance.get('/releve-heures/client');
      const timesheets = response.data;

      // Filtrer les relevés par semaine
      const start = new Date(startDate);
      const end = new Date(endDate);

      const filtered = timesheets.filter(ts => {
        const tsStart = new Date(ts.DateDebut);
        const tsEnd = new Date(ts.DateFin);

        // Vérifier si le relevé chevauche la période demandée
        return (tsStart >= start && tsStart <= end) ||
               (tsEnd >= start && tsEnd <= end) ||
               (tsStart <= start && tsEnd >= end);
      });

      return filtered;
    } catch (error) {
      console.error('Erreur lors de la récupération des relevés de la semaine:', error);
      throw error;
    }
  },

  // Compter les relevés en attente pour le client
  async countPending() {
    try {
      const response = await AxiosInstance.get('/releve-heures/count-pending');
      return response.data;
    } catch (error) {
      console.error('Erreur lors du comptage des relevés en attente:', error);
      throw error;
    }
  },

  // Récupérer les motifs d'absence
  async getMotifAbsence() {
    try {
      const response = await AxiosInstance.get('/releve-heures/motif');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des motifs d\'absence:', error);
      throw error;
    }
  },

  // Mettre à jour un relevé d'heures
  async update(id, data) {
    try {
      const response = await AxiosInstance.patch(`/releve-heures/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour du relevé d\'heures:', error);
      throw error;
    }
  },

  // Créer un relevé d'heures dans Tempo
  async createTempoRh(data) {
    try {
      const response = await AxiosInstance.post('/releve-heures', data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création du relevé d\'heures:', error);
      throw error;
    }
  }
};

export default releveHeuresService;

